import React from 'react'
import classNames from 'classnames'
import { UnderlineNavigationTab, UnderlineNavigationTabs } from './underlineNavigationTabs'
import './secondaryTabsRow.scss'

interface SecondaryTabsRowProps {
    tabs: UnderlineNavigationTab[]
    actions?: React.ReactNode
    className?: string
}

export function SecondaryTabsRow({ tabs, actions, className }: SecondaryTabsRowProps) {
    return (
        <div className={classNames('secondary-tabs-row', className)}>
            {tabs.length > 1 && <UnderlineNavigationTabs className="secondary-tabs-row__tabs" tabs={tabs} />}
            {actions && <div className="secondary-tabs-row__actions">{actions}</div>}
        </div>
    )
}
